import { render, staticRenderFns } from "./CourseDetailModal.vue?vue&type=template&id=31ad9866&scoped=true"
import script from "./CourseDetailModal.vue?vue&type=script&lang=js"
export * from "./CourseDetailModal.vue?vue&type=script&lang=js"
import style0 from "./CourseDetailModal.vue?vue&type=style&index=0&id=31ad9866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ad9866",
  null
  
)

export default component.exports